import CitySEOHead from "@/components/feature/CitySEOHead";
import FloridaHeroSection from "./components/HeroSection";
import FloridaCommunitiesWeServe from "./components/CommunitiesWeServe";
import FloridaCitiesDirectory from "./components/CitiesDirectory";
import FloridaStateResources from "./components/StateResources";
import FloridaFAQSection, { faqs as rawFaqs } from "./components/FAQSection";
import FloridaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqs = rawFaqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function FloridaPage() {
  return (
    <>
      <CitySEOHead
        city="Florida"
        state="Florida"
        stateAbbr="FL"
        route="/states/florida"
        title="Florida Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Florida — Orlando, Tampa, Panama City, Boca Raton, Key West. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Florida, United States"
        geoPosition="27.9944;-81.7603"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <div className="font-sans">
        <FloridaHeroSection />
        <FloridaCommunitiesWeServe />
        <FloridaCitiesDirectory />
        <FloridaStateResources />
        <FloridaFAQSection />
        <SEOCrossLinks state="FL" />
        <FloridaFinalCTA />
      </div>
    </>
  );
}